import { format, formatDuration, intervalToDuration } from "date-fns";
import _, { join, set } from "lodash";
import packageJson from "../../package.json";
import { TaskType } from "./constants";
import { getCssDetails } from "../data/services/API";

export function timestampRenderer(date) {
  if (_.isNil(date)) return null;

  const parsed = new Date(date);
  if (parsed.getTime() === 0) return null; // 0 epoch (UTC 1970-1-1)

  return format(parsed, "yyyy-MM-dd HH:mm:ss");
}
export function timestampMsRenderer(date) {
  if (_.isNil(date)) return null;

  const parsed = new Date(date);
  if (parsed.getTime() === 0) return null; // 0 epoch (UTC 1970-1-1)

  return format(parsed, "yyyy-MM-dd HH:mm:ss.SSS");
}

export function durationRenderer(durationMs) {
  const duration = intervalToDuration({ start: 0, end: durationMs });
  if (durationMs > 5000) {
    return formatDuration(duration);
  } else {
    return `${durationMs}ms`;
  }
}

export function taskHasResult(task) {
  const keys = Object.keys(task);
  return !(keys.length === 1 && keys[0] === "workflowTask");
}

export function astToQuery(node) {
  // leaf node
  if (node.operator !== undefined) {
    return node.field + node.operator + node.value;
  } else if (node.combinator !== undefined) {
    const clauses = node.rules
      .filter((rule) => !(rule.rules && rule.rules.length === 0)) // Ignore empty groups
      .map((rule) => astToQuery(rule));
    const wrapper = clauses.length > 1;

    let combinator = node.combinator.toUpperCase();

    return `${wrapper ? "(" : ""}${clauses.join(` ${combinator} `)}${
      wrapper ? ")" : ""
    }`;
  } else {
    return "";
  }
}

export function isFailedTask(status) {
  return (
    status === "FAILED" ||
    status === "FAILED_WITH_TERMINAL_ERROR" ||
    status === "TIMED_OUT" ||
    status === "CANCELED"
  );
}

export function defaultCompare(x, y) {
  if (x === undefined && y === undefined) return 0;

  if (x === undefined) return 1;

  if (y === undefined) return -1;

  if (x < y) return -1;

  if (x > y) return 1;

  return 0;
}

export function immutableReplaceAt(array, index, value) {
  const ret = array.slice(0);
  ret[index] = value;
  return ret;
}

export function isEmptyIterable(iterable) {
  // eslint-disable-next-line no-unused-vars, no-unreachable-loop
  for (const _ of iterable) {
    return false;
  }
  return true;
}

export function getBasename() {
  let basename = "/";
  try {
    basename = new URL(packageJson.homepage).pathname;
    console.log("helper", getBasename());
  } catch (e) {}
  return _.isEmpty(basename) ? "/" : basename;
}

// fetches parent location hostname
// export function getParentUrl() {
//   var isInIframe = window.location !== window.parent.location,
//     parentUrl = null;

//   if (isInIframe) {
//     // parentUrl = document.referrer;
//     parentUrl = new URL(document.referrer).hostname;
//   } else {
//     parentUrl = "brcmitsmsandbox.wolkenservicedesk.com";
//   }

//   return parentUrl;
// }

// fetches parent location hostname
export function getParentUrl() {
  var isInIframe = window.location !== window.parent.location,
    parentUrl = null;

  if (isInIframe) {
    parentUrl = new URL(document.referrer).hostname;
  } else {
    parentUrl = "brcmitsmsandbox.wolkenservicedesk.com";
  }
  return parentUrl;
}

export function getDisplayName(dispName) {
  if (dispName.startsWith("LABEL_")) {
    return dispName.replace("LABEL_", "");
  }
  return dispName;
}

// export function getParentUrl() {
//   var isInIframe = window.location !== window.parent.location,
//     parentUrl = null;

//   if (isInIframe) {
//     // parentUrl = document.referrer;
//     parentUrl = new URL(document.referrer).hostname;
//   } else {
//     parentUrl = "wolken-itsm-demo.wolkenservicedesk.com";
//   }

//   return parentUrl;
// }

// fetches the parent location object
export function getParentLocation() {
  var isInIframe = window.location !== window.parent.location;

  if (isInIframe) {
    // parentUrl = document.referrer;
    return new URL(document.referrer);
  }

  return window.location;
}

export const generateRandomText = () => {
  return Math.random().toString(36).slice(2);
};

export const delayFunc = function (func, delay = 500) {
  let timeout;
  return function (...args) {
    let context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(context, args);
    }, delay);
  };
};

export const valuesNameChange = (values) => {
  if (values.displayName !== "") {
    var str = values.displayName ? values.displayName : "";
    var words = str.split(" ");
    var mergedStr = words.join("_");
    values.name = mergedStr;
    values.taskReferenceName = mergedStr + "_ref";
  } else {
    values.name = "";
    values.taskReferenceName = "";
  }
};

export function findJoinNode(tasks, forkJoinTaskReferenceName) {
  let { task, tasks: allTasks, taskIndex } = findCurrentNode(
    tasks,
    forkJoinTaskReferenceName
  );
  const joinTaskObj = allTasks[taskIndex + 1];
  return joinTaskObj;
}

export function findCurrentNode(tasks, parentTaskReferenceName) {
  let taskIndex = -1;

  for (const task of tasks) {
    taskIndex++;
    if (task.taskReferenceName != parentTaskReferenceName) {
      if (task.type === TaskType.Switch) {
        const { defaultCase, decisionCases } = task;
        for (let index = 0; index < 2; index++) {
          if (index == 0) {
            const obj = findCurrentNode(defaultCase, parentTaskReferenceName);
            if (obj != null) {
              return obj;
            }
          } else if (index == 1) {
            if (decisionCases && !_.isEmpty(decisionCases)) {
              for (const key in decisionCases) {
                const decisionCase = decisionCases[key];
                const obj = findCurrentNode(
                  decisionCase,
                  parentTaskReferenceName
                );
                if (obj != null) {
                  return obj;
                }
              }
            }
          }
        }
      } else if (task.type === TaskType.ForkJoin) {
        if (task.forkTasks && task.forkTasks.length > 0) {
          for (let index = 0; index < task.forkTasks.length; index++) {
            const forktask = task.forkTasks[index];
            const obj = findCurrentNode(forktask, parentTaskReferenceName);
            if (obj != null) {
              return obj;
            }
          }
        }
      } else if (task.type === TaskType.DoWhile) {
        const { loopOver } = task;
        if (task.loopOver && task.loopOver.length > 0) {
          for (let index = 0; index < task.loopOver.length; index++) {
            const looptask = task.loopOver;
            const obj = findCurrentNode(looptask, parentTaskReferenceName);
            if (obj != null) {
              return obj;
            }
          }
        }
      } else if (taskIndex + 1 == tasks.length) {
        return null;
      }
    } else if (task.taskReferenceName === parentTaskReferenceName) {
      return { task, tasks, taskIndex };
    }
  }
  return null;
}
export const getTaskObj = function (tasks, taskRef) {
  if (tasks) {
    for (const task of tasks.values()) {
      if (!task) continue;

      if ( taskRef && 
        ((taskRef.startsWith(TaskType.EndOfSwitch) &&
          task.type === TaskType.Switch) ||
          (taskRef.startsWith(TaskType.EndOfForkJoin) &&
            task.type === TaskType.ForkJoin)) &&
        splitTaskReferenceName(task.taskReferenceName) ===
          splitTaskReferenceName(taskRef)
      ) {
        continue;
      } else if (
        task.type === TaskType.Switch &&
        splitTaskReferenceName(task.taskReferenceName) !==
          splitTaskReferenceName(taskRef)
      ) {
        const { defaultCase, decisionCases } = task;
        const defObj = getTaskObj(defaultCase, taskRef);
        if (defObj) {
          return defObj;
        }
        if (decisionCases && !_.isEmpty(decisionCases)) {
          for (const key in decisionCases) {
            const obj = getTaskObj(decisionCases[key], taskRef);
            if (
              obj &&
              splitTaskReferenceName(obj.taskReferenceName) ===
                splitTaskReferenceName(taskRef)
            ) {
              return obj;
            }
          }
        }
      } else if (
        task.type === TaskType.ForkJoin &&
        splitTaskReferenceName(task.taskReferenceName) !==
          splitTaskReferenceName(taskRef)
      ) {
        const { forkTasks } = task;
        if (forkTasks) {
          for (const fork of forkTasks.values()) {
            const obj = getTaskObj(fork, taskRef);
            if (obj) return obj;
          }
        }
      } else if (
        task.type === TaskType.DoWhile &&
        splitTaskReferenceName(task.taskReferenceName) !==
          splitTaskReferenceName(taskRef)
      ) {
        const { loopOver } = task;
        if (loopOver) {
          const obj = getTaskObj(loopOver, taskRef);
          if (obj) return obj;
        }
      } else if (
        task.type === TaskType.EndOfForkJoin &&
        splitTaskReferenceName(task.taskReferenceName) ===
          splitTaskReferenceName(taskRef)
      ) {
        const joinTaskIndex = _.findIndex(tasks, {
          taskReferenceName: taskRef,
        });
        let forkTask;
        // if join not first ele & prev task FORK_JOIN
        if (joinTaskIndex) forkTask = tasks[joinTaskIndex - 1];
        // if fork available add fork tasks to join
        if (forkTask) return { ...task, forkTasks: forkTask.forkTasks };
        // else return task
        else return task;
      } else {
        if (
          splitTaskReferenceName(task.taskReferenceName) ===
          splitTaskReferenceName(taskRef)
        ) {
          return task;
        }
      }
    }
  }
};

export const updateTaskList = function (tasks, taskToBeUpdated, prevTaskState) {
  if (tasks && taskToBeUpdated && prevTaskState) {
    const { taskReferenceName } = prevTaskState;
    let tempArr = [];
    for (const task of tasks.values()) {
      if (
        task.type === TaskType.Switch &&
        task.taskReferenceName !== taskReferenceName
      ) {
        const { defaultCase, decisionCases } = task;
        let updatedTask = { ...task };
        const defObj = updateTaskList(
          defaultCase,
          taskToBeUpdated,
          prevTaskState
        );
        let descObj = {};
        if (decisionCases && !_.isEmpty(decisionCases)) {
          for (const key in decisionCases) {
            const arr = updateTaskList(
              decisionCases[key],
              taskToBeUpdated,
              prevTaskState
            );
            descObj[key] = arr;
          }
        }

        updatedTask = { ...updatedTask, defaultCase: defObj };
        if (!_.isEmpty(descObj)) {
          updatedTask = { ...updatedTask, decisionCases: descObj };
        }
        tempArr.push(updatedTask);
      } else if (
        task.type === TaskType.ForkJoin &&
        task.taskReferenceName !== taskReferenceName
      ) {
        const { forkTasks } = task;
        if (forkTasks) {
          let forks = [];
          for (const fork of forkTasks.values()) {
            const arr = updateTaskList(fork, taskToBeUpdated, prevTaskState);
            forks.push(arr);
          }
          let updatedTask = { ...task, forkTasks: forks };
          let joinNode = findJoinNode(tasks, task.taskReferenceName);

          let lastTaskRefs = forkTasks.map((r) => _.last(r).taskReferenceName);
          if (joinNode.joinOn) {
            var filtered = joinNode.joinOn.filter(function (element) {
              return lastTaskRefs.indexOf(element) === -1;
            });

            let excludedArr = joinNode.joinOn.filter(
              (el) => !filtered.includes(el)
            );
            joinNode.joinOn = excludedArr;
          }
          joinNode.forkTasks = forks;

          tempArr.push(updatedTask);
        }
      } else if (
        task.type === TaskType.DoWhile &&
        task.taskReferenceName !== taskReferenceName
      ) {
        const { loopOver } = task;

        let updatedTask = { ...task };

        if (loopOver) {
          const updatedLoopOver = updateTaskList(
            loopOver,
            taskToBeUpdated,
            prevTaskState
          );
          if (updatedLoopOver)
            updatedTask = { ...updatedTask, loopOver: updatedLoopOver };
        }
        tempArr.push(updatedTask);
      } else {
        if (task.taskReferenceName === taskReferenceName) {
          tempArr.push(taskToBeUpdated);
        } else {
          tempArr.push(task);
        }
      }
    }
    return tempArr;
  }
};

export const deleteTaskFromList = function (tasks, taskRef) {
  if (tasks && taskRef) {
    let tempArr = [];
    for (const task of tasks.values()) {
      if (task.type === TaskType.Switch && task.taskReferenceName !== taskRef) {
        const { defaultCase, decisionCases } = task;
        let updatedTask = { ...task };
        const defObj = deleteTaskFromList(defaultCase, taskRef);

        let descObj = {};
        if (decisionCases && !_.isEmpty(decisionCases)) {
          for (const key in decisionCases) {
            const arr = deleteTaskFromList(decisionCases[key], taskRef);
            descObj[key] = arr;
          }
        }

        updatedTask = { ...updatedTask, defaultCase: defObj };
        if (!_.isEmpty(descObj)) {
          updatedTask = { ...updatedTask, decisionCases: descObj };
        }
        tempArr.push(updatedTask);
      } else if (
        task.type === TaskType.ForkJoin &&
        task.taskReferenceName !== taskRef
      ) {
        const { forkTasks } = task;
        if (forkTasks) {
          let forks = [];
          for (const fork of forkTasks.values()) {
            const arr = deleteTaskFromList(fork, taskRef);
            forks.push(arr);
          }
          let updatedTask = { ...task, forkTasks: forks };
          // let joinNode = findJoinNode(tasks, task.taskReferenceName);
          // joinNode.forkTasks = forks;

          // let arr = joinNode.joinOn.filter(function (item) {
          //   return item !== taskRef;
          // });

          let joinNode = findJoinNode(tasks, task.taskReferenceName);
          joinNode.forkTasks = forks;

          let lastTaskRefs = forkTasks.map((r) => _.last(r).taskReferenceName);
          if (joinNode.joinOn) {
            var filtered = joinNode.joinOn.filter(function (element) {
              return lastTaskRefs.indexOf(element) === -1;
            });

            let excludedArr = joinNode.joinOn.filter(
              (el) => !filtered.includes(el)
            );
            joinNode.joinOn = excludedArr;
          }
          tempArr.push(updatedTask);
        }
      } else if (
        task.type === TaskType.DoWhile &&
        task.taskReferenceName !== taskRef
      ) {
        const { loopOver } = task;
        let updatedTask = { ...task };
        const defObj = deleteTaskFromList(loopOver, taskRef);
        updatedTask = { ...updatedTask, loopOver: defObj };
        tempArr.push(updatedTask);
      } else {
        if (task.taskReferenceName !== taskRef) {
          tempArr.push(task);
        }

        const match = splitTaskReferenceName(taskRef);
        let taskObj = getTaskObj(tasks, taskRef);
        if (
          taskObj &&
          taskObj.type === TaskType.Switch &&
          taskObj.type !== TaskType.SwitchCase
        ) {
          let endSwitchTaskRerenceName = "";
          endSwitchTaskRerenceName = `${TaskType.EndOfSwitch}_${match}_ref`;
          if (endSwitchTaskRerenceName) {
            tempArr = tempArr.filter(
              (item) => item.taskReferenceName !== endSwitchTaskRerenceName
            );
          }
        } else if (
          taskObj &&
          taskObj.type === TaskType.ForkJoin &&
          taskObj.type !== TaskType.Fork
        ) {
          let joinTaskRerenceName = "";
          let joinNode = findJoinNode(tasks, taskObj.taskReferenceName);
          joinTaskRerenceName = joinNode ? joinNode.taskReferenceName : "";
          const endJoinTaskReferenceName = `${
            TaskType.EndOfForkJoin
          }_${splitTaskReferenceName(taskObj.taskReferenceName)}_ref`;

          if (joinTaskRerenceName) {
            tempArr = tempArr.filter(
              (item) => item.taskReferenceName !== joinTaskRerenceName
            );
          }
          if (endJoinTaskReferenceName) {
            tempArr = tempArr.filter(
              (item) => item.taskReferenceName !== endJoinTaskReferenceName
            );
          }
        } else if (taskObj && taskObj.type === TaskType.DoWhile) {
          let endDoWhileTaskReferenceName = "";
          endDoWhileTaskReferenceName = `${TaskType.EndOfDoWhile}_${match}_ref`;
          if (endDoWhileTaskReferenceName) {
            tempArr = tempArr.filter(
              (item) => item.taskReferenceName !== endDoWhileTaskReferenceName
            );
          }
        }
      }
    }

    if (taskRef.startsWith(TaskType.TriggerApproval)) {
      const taTaskIndex = tasks.findIndex(
        (task) => task.taskReferenceName === taskRef
      );
      if (taTaskIndex > 0) {
        const etTask = tasks[taTaskIndex + 4];
        if (etTask)
          tempArr = tempArr.filter(
            (task) => task.taskReferenceName !== etTask.taskReferenceName
          );
        // Switch Task
        const switchTask = tasks[taTaskIndex + 2];
        if (switchTask) {
          let endSwitchTaskReferenceName = "";
          const match = splitTaskReferenceName(switchTask.taskReferenceName);
          endSwitchTaskReferenceName = `${TaskType.EndOfSwitch}_${match}_ref`;
          if (endSwitchTaskReferenceName)
            tempArr = tempArr.filter(
              (task) => task.taskReferenceName !== endSwitchTaskReferenceName
            );
          tempArr = tempArr.filter(
            (task) => task.taskReferenceName !== switchTask.taskReferenceName
          );
        }
        //Fetch Approval Task
        const faTask = tasks[taTaskIndex + 1];
        if (faTask)
          tempArr = tempArr.filter(
            (task) => task.taskReferenceName !== faTask.taskReferenceName
          );
        // Start Trigger Task
        const stTask = tasks[taTaskIndex - 1];
        if (stTask) {
          tempArr = tempArr.filter(
            (task) => task.taskReferenceName !== stTask.taskReferenceName
          );
        }
      }
    }
    return tempArr;
  }
};

/* split task reference name */
export function splitTaskReferenceName(taskReferenceName) {
  const str = taskReferenceName;
  const regex = /_[a-zA-Z0-9]+_ref/;

  // Use the regular expression to extract the substring
  const match = str ? str.match(regex) : null;

  // If match is found, extract the substring without underscores
  const refText = match ? match[0].slice(1, -1).split("_")[0] : "";
  return refText;
}

export function checkFormValidity(
  field,
  meta,
  props,
  taskErrors,
  setTaskErrors
) {
  if (field && meta && props && taskErrors) {
    if (meta.error) {
      let errorObj = {};
      errorObj.error = meta.error;
      errorObj.fieldName = field.name;
      errorObj.fieldId =
        field.name + "_" + splitTaskReferenceName(props.taskReferenceName);
      const errorIndex = taskErrors.findIndex(
        (err) => err.fieldId === errorObj.fieldId
      );
      // add the errorObj to the taskErrors
      if (errorIndex === -1) {
        const arr = [...taskErrors];
        arr.push(errorObj);
        setTaskErrors(arr);
      } else {
        // update the errorObj in the taskErrors
        if (taskErrors[errorIndex].error !== errorObj.error) {
          let arr = [...taskErrors];
          arr = arr.filter((err) => err.fieldId !== errorObj.fieldId);
          arr.push(errorObj);
          setTaskErrors(arr);
        }
      }
    } else if (!meta.error && taskErrors.length) {
      // remove the errorObj from the taskErrors if the error has been resolved
      const errorIndex = taskErrors.findIndex(
        (err) =>
          err.fieldId ===
          field.name + "_" + splitTaskReferenceName(props.taskReferenceName)
      );
      if (errorIndex !== -1) {
        let arr = [...taskErrors];
        arr = arr.filter(
          (err) =>
            err.fieldId !==
            field.name + "_" + splitTaskReferenceName(props.taskReferenceName)
        );
        setTaskErrors(arr);
      }
    }
  }
}

export const setCssDetails = () => {
  return new Promise((resolve, reject) => {
    let theme = {};
    getCssDetails()
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.status === "Success" &&
          response.data.message === "Success"
        ) {
          const css = response.data.data;
          if (css.portalCssData) {
            theme.primaryColor = css.portalCssData.primaryCol
              ? css.portalCssData.primaryCol
              : "";
            theme.secondaryColor = css.portalCssData.secondaryCol
              ? css.portalCssData.secondaryCol
              : "";
            setUpTheme(theme);
            theme.fontFamily = css.portalCssData.fontName
              ? css.portalCssData.fontName
              : "";
            resolve(theme);
          } else {
            setUpTheme(theme);
            resolve(null);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        setUpTheme(theme);
        resolve(null);
      });
  });
};

function saveColor(hexColor, colorName) {
  if (!hexColor || !colorName) return;
  const key1 = `--theme-${colorName}`;
  const value1 = hexColor;
  document.documentElement.style.setProperty(key1, value1);
}

export function setUpTheme(theme) {
  const defaultPrimaryColor = "#009de1";
  const defaultAccentColor = "#ff4081";
  const primaryColor = theme?.primaryColor
    ? theme.primaryColor
    : defaultPrimaryColor;
  const secondaryColor = theme?.secondaryColor
    ? theme.secondaryColor
    : defaultAccentColor;
  const primaryComplementoryColor = theme?.primaryComplementoryColor
    ? theme.primaryComplementoryColor
    : defaultPrimaryColor;
  const secondaryComplementoryColor = theme?.secondaryComplementoryColor
    ? theme.secondaryComplementoryColor
    : defaultAccentColor;

  saveColor(primaryColor, "primary");
  saveColor(secondaryColor, "accent");
  saveColor(primaryComplementoryColor, "primary-complementory");
  saveColor(secondaryComplementoryColor, "accent-complementory");
  saveColor("#ff0000", "warn");

  // toggleDarkTheme();
}
